export const getEventId = ({eviteEvent, ecard}) => eviteEvent?.id ?? ecard?.id; // Accounts for QEC

export const getEventHostId = ({eviteEvent}) => eviteEvent.host_id;

export const selectIsHostViewing = ({eviteEvent}) => eviteEvent?.is_host_viewing;

export const selectEventOptionEnablePhotoSharing = ({eviteEvent}) =>
  eviteEvent?.options?.event_option_enable_photo_sharing;

export const selectHostIds = ({eviteEvent, details}) =>
  details && details.cohost.email !== eviteEvent.cohost_email1
    ? details.host_ids
    : eviteEvent.host_ids;

export const selectClassifiedCategory = ({eviteEvent}) =>
  eviteEvent?.options?.classified_category || '';

export const selectPendingHostIds = ({eviteEvent, details}) =>
  details && details.cohost.email !== eviteEvent.cohost_email1
    ? details.pending_host_ids
    : eviteEvent.pending_host_ids;

export const selectUsedAs = ({eviteEvent, ecard}) =>
  eviteEvent?.used_as ?? ecard?.event_data?.used_as;

export const selectEventStatus = ({eviteEvent, ecard}) =>
  eviteEvent?.status ?? ecard?.event_data?.status;
export const selectEventType = ({eviteEvent}) => eviteEvent.event_type;
export const selectEventGiftRegistryName = (state) => state.eviteEvent?.gift_registry_name;
export const selectEventGiftRegistryUrls = (state) => state.eviteEvent?.gift_registry_urls;
